// src/components/ui/Button/Button.jsx
// 从150+行简化到60行，保持核心功能

import React from 'react';
import styles from './Button.module.css';

const Button = ({
  children,
  variant = 'primary',  // 只保留3种：primary, secondary, danger
  size = 'md',         // 只保留3种：sm, md, lg
  icon,               // 图标支持
  loading = false,    // 加载状态
  disabled = false,   // 禁用状态
  className,
  onClick,
  type = 'button',
  ...props
}) => {
  // 构建CSS类名
  const buttonClasses = [
    styles.button,
    styles[variant],
    styles[size],
    loading && styles.loading,
    disabled && styles.disabled,
    icon && !children && styles.iconOnly,  // 只有图标的按钮
    className
  ].filter(Boolean).join(' ');

  // 处理点击事件
  const handleClick = (e) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <button
      type={type}
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled || loading}
      {...props}
    >
      {/* 加载状态 */}
      {loading && (
        <span className={styles.spinner} />
      )}
      
      {/* 图标 */}
      {icon && !loading && (
        <span className={styles.icon}>{icon}</span>
      )}
      
      {/* 文本内容 */}
      {children && (
        <span className={styles.text}>{children}</span>
      )}
    </button>
  );
};

export default Button;